/**
 * What a team-grid cell says — V10 §3.
 *
 * Pure and separate from the page so it can be proved without a browser, the
 * same split `attendanceMonth.ts` already uses.
 */

import type { AttendanceDayStatus } from '@virtuetasks/types';

/**
 * Which verdicts carry hours under the letter.
 *
 * Only the two where hours are the substance of the verdict. "L / 0.0h" would
 * be noise on a leave day and "A / 0.0h" merely restates the letter, and a grid
 * whose every cell has two lines is a grid nobody can scan.
 */
export const SHOWS_HOURS: AttendanceDayStatus[] = ['present', 'half_day'];

export function showsHours(status: AttendanceDayStatus | undefined): boolean {
  return Boolean(status && SHOWS_HOURS.includes(status));
}

/** One decimal — the same figure and precision as the row's "Attend h" total. */
export function cellHoursLabel(minutes: number): string {
  return `${(minutes / 60).toFixed(1)}h`;
}
